import { ReservationMode } from "../components/nj-reservation/ReservationMode";

export const DATA_STORE_KEY_LATEST_BOOKING_STEP = "latestBookingStep";
export const DATA_STORE_KEY_PHONE_NUMBER = "phoneNumber";
export const DATA_STORE_KEY_SESSION_CORRUPTED = "sessionCorrupted";
export const DATA_STORE_KEY_PAYMENT_METHOD = "paymentMethod";
export const DATA_STORE_KEY_PREBOOK_ID = "prebookId";
export const DATA_STORE_KEY_ORDER_TOTAL = "orderTotal";
export const DATA_STORE_KEY_TICKETS = "tickets";
export const DATA_STORE_KEY_PASSENGERS = "passangers";
export const DATA_STORE_KEY_PASSENGER_EMAIL = 'passangerEmail';
export const DATA_STORE_KEY_PREBOOK = 'prebook';
export const DATA_STORE_KEY_FROM_TO = 'fromToData';
export const DATA_STORE_KEY_FROM_TO_RETURN = 'fromToReturnData';
export const DATA_STORE_KEY_VALUE_SUFFIX = '_Value';
export const DATA_STORE_KEY_OUTWARD_VALUE = ReservationMode.Outward + DATA_STORE_KEY_VALUE_SUFFIX;
export const DATA_STORE_KEY_RETURN_VALUE = ReservationMode.Return + DATA_STORE_KEY_VALUE_SUFFIX;

export enum SessionHealthState {
    OKAY = "okay",
    CORRUPTED = "corrupted"
}

export function dataStore(): DataStore {
    return DataStore.getInstance()
}
class DataStore {

    static instance: DataStore

    private data: any[]

    constructor() {
        this.data = [];
    }

    static getInstance() {
        if (!DataStore.instance) {
            DataStore.instance = new DataStore();
        }
        return DataStore.instance;
    }
    public setLocalData(name: string, value: any): any {

        localStorage.setItem(name, JSON.stringify(value));
    }
    public getLocalData(name: string, defaultValue: any): any {
        let data: any = localStorage.getItem(name);
        if (data) {
            return JSON.parse(data,this.dateReviver)
        } else {
            return defaultValue
        }

    }
    public removeLocalData(name: string) {

        localStorage.removeItem(name);
    }



private dateReviver(key, value) {

    // If the value is a string and if it roughly looks like it could be a
    // JSON-style date string go ahead and try to parse it as a Date object.
    if(key=="context"){
       // console.log(key,value)

    if ('string' === typeof value && /^\d{4}-[01]\d-[0-3]\dT[012]\d(?::[0-6]\d){2}\.\d{3}Z$/.test(value)) {
       // console.log(value)
      var date = new Date(value);
     // console.log(date)
      // If the date is valid then go ahead and return the date object.
      if (+date === +date) {
        return date;
      }
    }
}
    // If a date was not returned, return the value that was passed in.
    return value;
  }
    public setSessionData(name: string, value: any): any {

        sessionStorage.setItem(name, JSON.stringify(value));
        this.sessionDataChanged(name, sessionStorage.getItem(name))
    }

    public getSessionData(name: string, defaultValue: any = null): any {
        let data: any = sessionStorage.getItem(name);
        if (data) {
            return JSON.parse(data,this.dateReviver)
        } else {
            return defaultValue
        }

    }
    public parseJson(json: string, defaultValue: any = null): any {
      if(json){
            return JSON.parse(json,this.dateReviver)
        } else {
            return defaultValue
        }

    }
    public removeSessionData(name: string) {
        sessionStorage.removeItem(name);
        this.sessionDataRemoved(name)
    }

    public resetSessionData() {
        dataStore().removeSessionData(ReservationMode.Outward)
        dataStore().removeSessionData(DATA_STORE_KEY_OUTWARD_VALUE)
        dataStore().removeSessionData(ReservationMode.Return)
        dataStore().removeSessionData(DATA_STORE_KEY_RETURN_VALUE)
        dataStore().removeSessionData(DATA_STORE_KEY_PREBOOK)
        dataStore().removeSessionData(DATA_STORE_KEY_PREBOOK_ID)
        dataStore().removeSessionData(DATA_STORE_KEY_FROM_TO)
        dataStore().removeSessionData(DATA_STORE_KEY_FROM_TO_RETURN)
        dataStore().removeSessionData(DATA_STORE_KEY_LATEST_BOOKING_STEP);
        dataStore().removeSessionData(DATA_STORE_KEY_PHONE_NUMBER);
		dataStore().removeSessionData(DATA_STORE_KEY_PAYMENT_METHOD);
		dataStore().setSessionData(DATA_STORE_KEY_SESSION_CORRUPTED, SessionHealthState.OKAY);
		dataStore().removeSessionData(DATA_STORE_KEY_TICKETS);
		dataStore().removeSessionData(DATA_STORE_KEY_ORDER_TOTAL);
    }

    public resetAllSessionData() {
        dataStore().removeSessionData(ReservationMode.Outward)
        dataStore().removeSessionData(DATA_STORE_KEY_OUTWARD_VALUE)
        dataStore().removeSessionData(ReservationMode.Return)
        dataStore().removeSessionData(DATA_STORE_KEY_RETURN_VALUE)
        dataStore().removeSessionData(DATA_STORE_KEY_PASSENGERS)
        dataStore().removeSessionData(DATA_STORE_KEY_PASSENGER_EMAIL)
        dataStore().removeSessionData(DATA_STORE_KEY_FROM_TO)
        dataStore().removeSessionData(DATA_STORE_KEY_FROM_TO_RETURN)
        dataStore().removeSessionData(DATA_STORE_KEY_PREBOOK)
        dataStore().removeSessionData(DATA_STORE_KEY_PREBOOK_ID)
        dataStore().removeSessionData(DATA_STORE_KEY_LATEST_BOOKING_STEP);
        dataStore().removeSessionData(DATA_STORE_KEY_PHONE_NUMBER);
		dataStore().removeSessionData(DATA_STORE_KEY_PAYMENT_METHOD);
        dataStore().setSessionData(DATA_STORE_KEY_SESSION_CORRUPTED, SessionHealthState.OKAY);
		dataStore().removeSessionData(DATA_STORE_KEY_TICKETS);
		dataStore().removeSessionData(DATA_STORE_KEY_ORDER_TOTAL);
	}


    public setData(name: string, value: string): any {
        //  console.log(name)
        var result = this.data.filter(function (element: any) {
            if (element.key == name) {
                element.val = value
                return true
            }
        })
        //  console.log(result)
        if (result.length == 0) {
            this.data.push({ key: name, val: value },)
        }
    }
    public removeData(name: string) {
        //  console.log(name)
        var indexFound = -1
        var result = this.data.filter(function (element: any, index: number) {
            if (element.key == name) {
                indexFound = index
                return true
            }
        })

        if (result && indexFound > -1) {
            this.data.splice(indexFound, 1);
        }
    }

    public getData(name: string, defaultValue?: string): any {
        var output = null
        var result = this.data.filter(function (element: any) {
            if (element.key == name) {
                return true
            }
        })
        if (defaultValue) {
            output = defaultValue
        }
        if (result.length > 0) {
            if (result[0]["val"]) {
                output = result[0]["val"]
            }
        }
        return output
    }

    private sessionDataChanged(dataName: string, data: any) {
        let event = new CustomEvent('sessionDataChanged', {
            detail: {
                sessionName: dataName,
                sessionData: data
            }
        });

        window.dispatchEvent(event);
    }

    private sessionDataRemoved(dataName: string) {
        let event = new CustomEvent('sessionDataRemoved', {
            detail: {
                sessionName: dataName
            }
        });

        window.dispatchEvent(event);
    }
}
